import React from 'react'
import moment from 'moment';

import SalesOrderInvoiceTable from 'components/Invoices/SalesOrderInvoiceTable';
import styles from 'components/Invoices/Invoice.module.scss';

class SalesOrderInvoice extends React.Component {
  
  formatCurrency = (amount) => {
    return (new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount))
  };

  render = () => {
    return (
      <div className={styles.invoice}>
        <div className={styles.brand}>
          <img style={{ Width: "100%" }} src={this.props.user.companyLogo} alt={this.props.user.name} />
        </div>
        <div className={styles.addresses}>
          <div>
            <div className={`${styles.valueTable} ${styles.to}`}>
              <div className={styles.row}>
                <div className={styles.label}>Invoice #</div>
                <div className={styles.value}>{this.props.info.displayId}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Invoice Date</div>
                <div className={`${styles.value} ${styles.date}`}>{moment(this.props.info.paymentDate).format('DD/MM/YYYY')}</div>
              </div>
              {/*<div className={styles.row}>
                <div className={styles.label}> Due Date</div>
                <div className={`${styles.value} ${styles.date}`}>{moment(this.props.info.end_date).format('DD/MM/YYYY')}</div>
              </div>*/}
            </div>
          </div>
          <div className={`${styles.valueTable} ${styles.from}`}>
           {/*<strong>Amazing Company</strong><br />
              123 Kensington Ave<br />
              Toronto, ON, Canada &nbsp;A1B2C3<br />
              416-555-1234*/
              }
             <div className={styles.row}>
              <div className={styles.label}>Name</div>
              <div className={styles.value}>{this.props.info.customerName}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Phone</div>
              <div className={styles.value}>{this.props.info.customerPhone}</div>
            </div>
          </div>
        </div>
        <SalesOrderInvoiceTable products={this.props.info.products} payments={this.props.info.payments}/>
        <br></br>
        <div className={styles.totalContainer}>
          <div>
            <div className={styles.valueTable}>
              <div className={styles.row}>
                <div className={styles.label}>Sub Total</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.subTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Tax ({this.taxRate}%)</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.taxTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Invoice Amount</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.currentAmount)}</div>
              </div>
            </div>
          </div>
          <div>
            <div className={styles.valueTable}>
              <div className={styles.row}>
                <div className={styles.label}>Grand Total</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.grandTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Status</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.props.info.status}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <img style={{ Width: "100%" }} src={process.env.REACT_APP_INVOICE_FOOTER_URL} alt={"Thank-you for your business"} />
        </div>
      </div>
    )
  }
};

export default SalesOrderInvoice;